import { displayLatLonInCompassFormat } from '@deckee/utilities';
import React from 'react';
import { policemanBust } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Police',
  synonyms: 'officer',
  group: 'standardMarker',
  typeUrl: 'police',
  icon: {
    baseShape: policemanBust,
    iconColor: '#fff',
    markerColor: '#56AC5C',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-facilities',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'policeMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Police',
      itemTitleFunction: () => 'Police',
    },
    creationOptions: {
      menuText: 'Police',
      newTitle: 'Police',
      titlePlaceholder: 'Title',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker is used to indicate a place where water police, land-based
          police, or a similar authority can be found.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Police',
    description: displayLatLonInCompassFormat(marker.latLon),
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
